import { createStyles } from 'antd-style'

type Props = {
  onRow?: boolean
  isHoverAlternative?: boolean
}

export const useStyles = createStyles(
  ({ token }, { onRow = false, isHoverAlternative = false }: Props) => ({
    table: {
      '.ant-table-thead > tr > th': {
        borderRadius: '0px !important',
        padding: '12px 16px !important',
        borderBottom: `1px solid ${token.colorBorderSecondary}`
      },

      '.ant-table-row > td:first-child, .ant-table-summary > tr > td:first-child':
        {
          borderLeft: `1px solid ${token.colorBorderSecondary}`
        },

      '.ant-table-cell, .ant-table-summary .ant-table-cell': {
        padding: '8px 16px !important'
      },

      '.ant-table-row > td:last-child, .ant-table-summary > tr > td:last-child':
        {
          borderRight: `1px solid ${token.colorBorderSecondary}`
        },

      '.ant-pagination': {
        border: `1px solid ${token.colorBorderSecondary}`,
        backgroundColor: token.colorWhite,
        borderTop: 0,
        borderRadius: '0 0 8px 8px',
        margin: '0px !important',
        padding: 16
      },

      '.ant-pagination-total-text': {
        flex: 1,
        color: token.colorTextTertiary
      },

      '.ant-table-cell-with-append': {
        display: 'flex',
        height: '57px',
        alignContent: 'center',
        alignItems: 'center',
        gap: '16px'
      },

      '.ant-table-cell-row-hover:not(.ant-table-cell-fix-right)': {
        backgroundColor: isHoverAlternative
          ? `${token.colorFillContentHover} !important`
          : undefined
      },

      '.ant-table-row': {
        cursor: onRow ? 'pointer' : 'auto',

        '.ant-table-cell-fix-right': {
          cursor: 'auto'
        }
      },

      '.ant-table-summary > tr:last-child > td': {
        borderBottom: `1px solid ${token.colorBorderSecondary}`
      },

      '.ant-table-summary > tr:hover > td': {
        backgroundColor: isHoverAlternative
          ? `${token.colorFillContentHover} !important`
          : undefined
      }
    }
  })
)
